import services from 'services/services';

export const pay = async (payload) => {
	const url = `/payments/pay`;

	try {
		const { data } = await services.post(url, payload);
		return Promise.resolve(data);
	} catch (error) {
		return Promise.reject(error);
	}
};
